import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_label_hdr_RowClass} from '../../../dbschema';

export class CmsLabelContainerModel extends BaseContainerModel {

  bl_cms_label_hdr: bl_cms_label_hdr_RowClass = new bl_cms_label_hdr_RowClass();
}
